export default "<div class=\"age-chart__wrapper\">\n<div class=\"age-chart__content\">\n</div>\n</div> \n\n\n"